/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 16.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import DataProvider from "../../../DataProvider";
import {Link} from "react-router";
import _ from "underscore";
import {vsprintf} from 'sprintf-js';
import ViewText from "./ViewText";

/**
 * Used for displaying e-mail with mailto link.
 * Specify in JSON Schema as follows:
 *  {
 *      "type": "string",
 *      "format": "email"
 *  }
 *
 * Or specify in UI Schea as follows:
 *  {
 *      "ui:widget": "email"
 *  }
 */
class ViewEmail extends React.Component {
    static propTypes = {
        dataProvider: PropTypes.instanceOf(DataProvider).isRequired,
        field: PropTypes.string.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        /**
         * @type {DataProvider}
         */
        let dataProvider = this.props.dataProvider;
        let value = dataProvider.getValue(this.props.field);
        if (!value) return null;
        return (
            <a href={"mailto:" + value}>{value}</a>
        );
    }
}

export default ViewEmail;
